"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestGetSummary = exports.requestDelete = exports.requestPost = exports.requestGet = void 0;
const humps_1 = require("humps");
const requests_1 = require("./requests");
const token_1 = require("./token");
const functionsLookup = {
    Community: parseICommunity,
    Favorites: parseIFavorite,
    MHBOListing: parseIMHBOListing,
    MobileHome: parseIMobileHome,
};
/**
 * Performs a GET request to mhbo api.
 *
 * @param creds The authentication credential for the API request.
 * @param environment An optional override of the environment to utilize.
 * @param fetchExecutor An instance of the request executor.
 * @returns An array of mobile home results.
 */
function requestGetSummary(url, creds, environment, fetchExecutor) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield (0, requests_1.authenticatedRequest)((0, token_1.token)(creds), "GET", url, environment, fetchExecutor);
        if (response.json) {
            const json = yield response.json();
            const { page, query, results, resultsCount, totalCount } = (0, humps_1.camelizeKeys)(json);
            const parsedResults = results.map((listing) => parseIMHBOListing(listing));
            return {
                query,
                page: parseFloat(page),
                resultsCount: parseFloat(resultsCount),
                totalCount: parseFloat(totalCount),
                results: parsedResults,
            };
        }
        return { page: 0, query: "", resultsCount: 0, totalCount: 0, results: [] };
    });
}
exports.requestGetSummary = requestGetSummary;
/**
 * Performs a GET request to mhbo api.
 *
 * @param creds The authentication credential for the API request.
 * @param environment An optional override of the environment to utilize.
 * @param fetchExecutor An instance of the request executor.
 * @returns An array of mobile home results.
 */
function requestGet(url, creds, returnType, environment, fetchExecutor) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield (0, requests_1.authenticatedRequest)((0, token_1.token)(creds), "GET", url, environment, fetchExecutor);
        if (response.json) {
            const json = yield response.json();
            const parseFunction = functionsLookup[returnType];
            return (json.map((result) => {
                return parseFunction(result);
            }) || []);
        }
        return [];
    });
}
exports.requestGet = requestGet;
/**
 * Performs a POST request to mhbo api.
 *
 * @param creds The authentication credential for the API request.
 * @param environment An optional override of the environment to utilize.
 * @param fetchExecutor An instance of the request executor.
 * @returns The updated result.
 */
function requestPost(url, creds, returnType, environment, fetchExecutor, body) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield (0, requests_1.authenticatedRequest)((0, token_1.token)(creds), "POST", url, environment, fetchExecutor, body);
        if (response.json) {
            const json = yield response.json();
            const {} = (0, humps_1.camelizeKeys)(json);
            const parseFunction = functionsLookup[returnType];
            return parseFunction(json);
        }
        return {};
    });
}
exports.requestPost = requestPost;
/**
 * Performs a DELETE request to mhbo api.
 *
 * @param creds The authentication credential for the API request.
 * @param environment An optional override of the environment to utilize.
 * @param fetchExecutor An instance of the request executor.
 * @returns indicator message
 */
function requestDelete(url, creds, environment, fetchExecutor) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield (0, requests_1.authenticatedRequest)((0, token_1.token)(creds), "DELETE", url, environment, fetchExecutor);
        if (response.json) {
            const json = yield response.json();
            return json;
        }
        return {};
    });
}
exports.requestDelete = requestDelete;
function parseIMHBOListing(result) {
    const listing = __rest((0, humps_1.camelizeKeys)(result), []);
    const { address, entityType, listingTypeId } = listing;
    const { latitude, longitude } = address;
    return Object.assign(Object.assign({}, listing), { address: {
            latitude: parseFloat(latitude),
            longitude: parseFloat(longitude),
        }, entityType: parseFloat(entityType), listingTypeId: parseFloat(listingTypeId) });
}
function parseSearchSummary(result) {
    const listing = __rest((0, humps_1.camelizeKeys)(result), []);
    const { address, entityType, listingTypeId } = listing;
    const { latitude, longitude } = address;
    return Object.assign(Object.assign({}, listing), { address: {
            latitude: parseFloat(latitude),
            longitude: parseFloat(longitude),
        }, entityType: parseFloat(entityType), listingTypeId: parseFloat(listingTypeId) });
}
function parseIMobileHome(result) {
    const home = __rest((0, humps_1.camelizeKeys)(result), []);
    const { address, entityType, listingTypeId, locationStatusId } = home;
    const { latitude, longitude, lotNum } = address;
    return Object.assign(Object.assign({}, home), { address: Object.assign(Object.assign({}, address), { latitude: parseFloat(latitude), longitude: parseFloat(longitude), lotNum: lotNum === null ? lotNum : parseFloat(lotNum) }), entityType: parseFloat(entityType), listingTypeId: parseFloat(listingTypeId), locationStatusId: parseFloat(locationStatusId) });
}
function parseICommunity(result) {
    const community = __rest((0, humps_1.camelizeKeys)(result), []);
    const { address, entityType, listingTypeId, mobilehomes = [] } = community;
    const { latitude, longitude, lotNum } = address;
    return Object.assign(Object.assign({}, community), { address: Object.assign(Object.assign({}, address), { latitude: parseFloat(latitude), longitude: parseFloat(longitude), lotNum: lotNum === null ? lotNum : parseFloat(lotNum) }), entityType: parseFloat(entityType), listingTypeId: parseFloat(listingTypeId), mobilehomes: mobilehomes.map((home) => parseIMHBOListing(home)) });
}
function parseIFavorite(result) {
    const listing = __rest((0, humps_1.camelizeKeys)(result), []);
    return Object.assign({}, listing);
}
